export function startTeletypeAssembleEffect({ imgPanelEl }) {
  if (!imgPanelEl) return () => {};

  const carriage = imgPanelEl.querySelector('.teletype-carriage');
  if (!carriage) return () => {};

  let jitterInterval = setInterval(() => {
    if (!carriage.isConnected) {
      clearInterval(jitterInterval);
      jitterInterval = null;
      return;
    }
    const jitter = (Math.random() - 0.5) * 2;
    carriage.style.transform = `translateX(${jitter}px)`;
  }, 50);

  const stopTimeout = setTimeout(() => {
    if (jitterInterval) {
      clearInterval(jitterInterval);
      jitterInterval = null;
    }
    if (carriage) carriage.style.transform = '';
  }, 3500);

  return () => {
    if (jitterInterval) clearInterval(jitterInterval);
    clearTimeout(stopTimeout);
  };
}
